const ERROR_TYPES = {
  INVALID_EMAIL: "Invalid Email",
  INVALID_PASSWORD: "Invalid Password",
};

export { ERROR_TYPES };
